export function getdata(){
	var obj = {
			headDataI: [
				{
					title: "序号",
					prop: "groud",
					custom: true,
				}, {
					title: "税目",
					prop: "ccxwyh_1_x_1",
					
					custom: true,
				}, {
					title: "税款所属期起",
					prop: "ccxwyh_1_x_2",
					
					custom: true,
				}, {
					title: "税款所属期止",
					prop: "ccxwyh_1_x_3",
					
					custom: true,
				}, {
					title: "减免性质代码和项目名称",
					prop: "ccxwyh_1_x_4",
					
					custom: true,
				}, {
					title: "减免税额",
					prop: "ccxwyh_1_x_5",
					
					custom: true,
				} ],
			tableDataI: [{
				groud: 1,
				disabledccxwyh_1_x_1: true,
				disabledccxwyh_1_x_2: true,
				disabledccxwyh_1_x_3: true,
				disabledccxwyh_1_x_4: true,
				disabledccxwyh_1_x_5: true,
				ccxwyh_1_x_1: {
					cellCode: "ccxwyh_1_b1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_2: {
					cellCode: "ccxwyh_1_b1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_3: {
					cellCode: "ccxwyh_1_b1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_4: {
					cellCode: "ccxwyh_1_b1_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_5: {
					cellCode: "ccxwyh_1_b1_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
		
			}, {
				groud: 2,
				disabledccxwyh_1_x_1: false,
				disabledccxwyh_1_x_2: false,
				disabledccxwyh_1_x_3: false,
				disabledccxwyh_1_x_4: false,
				disabledccxwyh_1_x_5: false,
				ccxwyh_1_x_1: {
					cellCode: "ccxwyh_1_b2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_2: {
					cellCode: "ccxwyh_1_b2_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_3: {
					cellCode: "ccxwyh_1_b2_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_4: {
					cellCode: "ccxwyh_1_b2_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_5: {
					cellCode: "ccxwyh_1_b2_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				groud: '小计',
				disabledccxwyh_1_x_1: false,
				disabledccxwyh_1_x_2: false,
				disabledccxwyh_1_x_3: false,
				disabledccxwyh_1_x_4: false,
				disabledccxwyh_1_x_5: false,
				ccxwyh_1_x_1: {
					cellCode: "ccxwyh_1_b3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_2: {
					cellCode: "ccxwyh_1_b3_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_3: {
					cellCode: "ccxwyh_1_b3_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_4: {
					cellCode: "ccxwyh_1_b3_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwyh_1_x_5: {
					cellCode: "ccxwyh_1_b3_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}],
	}
	return obj
}
